<template>
  <BjInputNumber
    v-model="id"
    :disabled="disabled"
    :readonly="readonly"
    :size="size"
    :placeholder="placeholder || $t('inputText')"
    :maxlength="maxlength"
    :max="max"
    :min="min"
    :clearable="clearable"
    :per-milage="perMilage"
    :precision="precision"
    :not-auto-zero="notAutoZero"
    @blur="onBlur"
  >
    <template slot="prepend">
      <slot name="prepend" />
    </template>
    <template slot="append">
      <slot name="append" />
    </template>
  </BjInputNumber>
</template>
<script>
export default {
  name: 'BjInputMoney',
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'mini',
    },
    placeholder: {
      type: String,
      default: '',
    },
    // 千分号
    perMilage: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
      default: 9,
    },
    max: {
      type: [Number, String],
      default: null,
    },
    min: {
      type: [Number, String],
      default: '',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    precision: {
      type: Number,
      default: 2,
    },
    // 空值时，不自动变为0；
    notAutoZero: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: null,
    };
  },
  watch: {
    value: {
      handler(v) {
        this.id = v;
      },
      immediate: true,
    },
    id(v) {
      this.$emit('input', v);
      this.$emit('change', v);
    },
  },
  activated() {
    this.id = this.value;
  },
  mounted() {},
  methods: {
    onBlur(v) {
      this.$emit('blur');
    },
  },
};
</script>
<style scoped></style>
